// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cursola: PokeData = {
  "id": 864,
  "name": "cursola",
  "height": 10,
  "weight": 4,
  "base_experience": 179,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "tackle",
    "disable",
    "night-shade",
    "harden",
    "curse",
    "spite",
    "perish-song",
    "mirror-coat",
    "ancient-power",
    "grudge",
    "astonish",
    "power-gem",
    "hex",
    "strength-sap"
  ],
  "moves": [
    "tackle",
    "night-shade",
    "curse",
    "ancient-power",
    "shadow-ball",
    "poltergeist",
    "shadow-claws",
    "confuse-ray",
    "spectral-chain",
    "shadow-sneak",
    "shadow-dagger",
    "spectral-snatch",
    "soul-sacrifice"
  ],
  "evolution_chain": {
    "id": 113,
    "item": null,
    "species": [
      {
        "name": "corsola",
        "order": 254,
        "types": [
          PokeType.WATER,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cursola",
        "order": 864,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 222,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 48,
    "ability_power": 232
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
